module.exports = __webpack_public_path__ + "static/media/help-support.36173907.svg";